import { CssBaseline, ThemeProvider } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import useSettings from "hooks/useSettings";
import { useMemo } from "react";
import { Toaster } from "react-hot-toast";
import { useRoutes } from "react-router-dom";
import routes from "routes";
import "./i18";
import { ukoTheme } from "./theme";

function App() {
  const allPages = useRoutes(routes);
  const { settings } = useSettings();

  const appTheme = useMemo(() => ukoTheme(settings), [settings]);

  const toasterOptions = useMemo(
    () => ({
      style: {
        fontWeight: 500,
        fontFamily: "'Montserrat', sans-serif",
      },
    }),
    []
  );

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <Toaster toastOptions={toasterOptions} />
        {allPages}
        <SpeedInsights />
        <Analytics />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
